export type AmenityCategory =
  | 'kitchen'
  | 'laundry'
  | 'bathroom'
  | 'climate'
  | 'entertainment'
  | 'sports'
  | 'outdoor'
  | 'safety'
  | 'connectivity'
  | 'parking';

export type AmenityId =
  // Kitchen
  | 'oven'
  | 'microwave'
  | 'dishwasher'
  | 'fridge'
  | 'freezer'
  | 'coffeeMaker'
  | 'kettle'
  | 'toaster'
  // Laundry
  | 'washingMachine'
  | 'dryer'
  | 'iron'
  // Bathroom
  | 'bathtub'
  | 'shower'
  | 'hairDryer'
  // Climate
  | 'heating'
  | 'airConditioning'
  | 'fireplace'
  | 'woodStove'
  | 'fan'
  // Entertainment
  | 'tv'
  | 'projector'
  | 'speakers'
  | 'wifi'
  | 'boardGames'
  | 'books'
  | 'comics'
  | 'billiards'
  | 'gameConsole'
  // Sports
  | 'pingPongTable'
  | 'bikesAvailable'
  | 'paddle'
  | 'canoe'
  | 'windsurf'
  | 'wingfoil'
  // Outdoor
  | 'garden'
  | 'terrace'
  | 'bbq'
  | 'pool'
  | 'hotTub'
  | 'hammock'
  | 'gardenFurniture'
  // Safety
  | 'smokeDetector'
  | 'firstAidKit'
  | 'fireExtinguisher'
  // Connectivity
  | 'workDesk'
  // Parking
  | 'parking'
  | 'garage'
  | 'evCharger';

export interface AmenityDefinition {
  id: AmenityId;
  category: AmenityCategory;
}

export const AMENITIES: AmenityDefinition[] = [
  // Kitchen
  { id: 'oven', category: 'kitchen' },
  { id: 'microwave', category: 'kitchen' },
  { id: 'dishwasher', category: 'kitchen' },
  { id: 'fridge', category: 'kitchen' },
  { id: 'freezer', category: 'kitchen' },
  { id: 'coffeeMaker', category: 'kitchen' },
  { id: 'kettle', category: 'kitchen' },
  { id: 'toaster', category: 'kitchen' },
  // Laundry
  { id: 'washingMachine', category: 'laundry' },
  { id: 'dryer', category: 'laundry' },
  { id: 'iron', category: 'laundry' },
  // Bathroom
  { id: 'bathtub', category: 'bathroom' },
  { id: 'shower', category: 'bathroom' },
  { id: 'hairDryer', category: 'bathroom' },
  // Climate
  { id: 'heating', category: 'climate' },
  { id: 'airConditioning', category: 'climate' },
  { id: 'fireplace', category: 'climate' },
  { id: 'woodStove', category: 'climate' },
  { id: 'fan', category: 'climate' },
  // Entertainment
  { id: 'tv', category: 'entertainment' },
  { id: 'projector', category: 'entertainment' },
  { id: 'speakers', category: 'entertainment' },
  { id: 'wifi', category: 'entertainment' },
  { id: 'boardGames', category: 'entertainment' },
  { id: 'books', category: 'entertainment' },
  { id: 'comics', category: 'entertainment' },
  { id: 'billiards', category: 'entertainment' },
  { id: 'gameConsole', category: 'entertainment' },
  // Sports
  { id: 'pingPongTable', category: 'sports' },
  { id: 'bikesAvailable', category: 'sports' },
  { id: 'paddle', category: 'sports' },
  { id: 'canoe', category: 'sports' },
  { id: 'windsurf', category: 'sports' },
  { id: 'wingfoil', category: 'sports' },
  // Outdoor
  { id: 'garden', category: 'outdoor' },
  { id: 'terrace', category: 'outdoor' },
  { id: 'bbq', category: 'outdoor' },
  { id: 'pool', category: 'outdoor' },
  { id: 'hotTub', category: 'outdoor' },
  { id: 'hammock', category: 'outdoor' },
  { id: 'gardenFurniture', category: 'outdoor' },
  // Safety
  { id: 'smokeDetector', category: 'safety' },
  { id: 'firstAidKit', category: 'safety' },
  { id: 'fireExtinguisher', category: 'safety' },
  // Connectivity
  { id: 'workDesk', category: 'connectivity' },
  // Parking
  { id: 'parking', category: 'parking' },
  { id: 'garage', category: 'parking' },
  { id: 'evCharger', category: 'parking' },
];
